<template>
  <div class="home">
    <Header></Header>
    <div class="banner">
      <el-carousel trigger="click" height="640px" indicator-position="none">
        <el-carousel-item v-for="(item, index) in bannerImgUrl" :key="index">
          <div v-if="index===0" class="banner-bg banner-first">
            <router-link :to="item.href">
              <div class="banner-content width_fixed">
                <div class="banner-content-text">
                  <p class="banner-title">数据驱动决策<br></p>
                  <p class="banner-text">科技升级，洞见未来</p>
                  <div class="layer-btn">了解更多</div>
                </div>
                <div class="banner-icon">
                  <img class="banner-icon1" src="@/assets/img/pc/banner/banner1_index1.png">
                  <img class="banner-icon2" src="@/assets/img/pc/banner/banner1_index2.png">
                  <img class="banner-icon3" src="@/assets/img/pc/banner/banner1_index3.png">
                  <img class="banner-icon4" src="@/assets/img/pc/banner/banner1_index1_icon1.png">
                  <img class="banner-icon5" src="@/assets/img/pc/banner/banner1_index1_icon2.png">
                  <img class="banner-icon6" src="@/assets/img/pc/banner/banner1_index1_icon3.png">
                </div>
              </div>
            </router-link>
          </div>
          <a :href="item.href" target="_brank"><div else class="banner-bg" :style="'backgroundImage:url('+item.imgUrl+')'"></div></a>
        </el-carousel-item>
      </el-carousel>
    </div>
    <div class="serve">
      <div class="serve-main width_fixed">
        <ul>
          <li>
            <div class="icon">
            </div>
            <h5>信息安全</h5>
            <p>信息安全是企业长久发展的保障，霖梓控股高度重视数据及隐私安全，建立网络安全和隐私保护管理闭环，定期组织员工进行信息安全培训学习，在完善的安全体系保障下，霖梓控股获得公安部信息系统安全等级三级认证证书。信息安全是霖梓长期稳定发展的保障，更是数据驱动的基石。</p>
          </li>
            <div class="icon_space">
            </div>
          <li>
            <div class="icon">
            </div>
            <h5>合规制度</h5>
            <p>霖梓控股将基于信任的合规文化融入到集团管理文化中，坚持从法律监管、信息安全、反腐廉洁等多个角度坚守合规原则，赢得合作伙伴信任，实现企业可持续发展。</p>
          </li>
        </ul>
      </div>
    </div>
    <div class="business">
      <div class="business-main width_fixed">
        <ul>
          <router-link to="/business?type=a" tag="li">
            <div class="li-box"></div>
            <div class="li-content">
              <h3>易借速贷</h3>
              <p>金融科技平台</p>
              <i class="icon"></i>
              <div>查看详情</div>
            </div>
          </router-link>
          <router-link to="/business?type=b" tag="li">
            <div class="li-box"></div>
            <div class="li-content">
              <h3>PITPAT</h3>
              <p>智能家用健身品牌</p>
              <i class="icon"></i>
              <div>查看详情</div>
            </div>
          </router-link>
          <router-link to="/business?type=c" tag="li">
            <div class="li-box"></div>
            <div class="li-content">
              <h3>瑞博国际</h3>
              <p>物业管理</p>
              <i class="icon"></i>
              <div>查看详情</div>
            </div>
          </router-link>
          <router-link to="/business?type=d" tag="li">
            <div class="li-box"></div>
            <div class="li-content">
              <h3>物流管理</h3>
              <p>智能化解决方案</p>
              <i class="icon"></i>
              <div>查看详情</div>
            </div>
          </router-link>
        </ul>
      </div>
    </div>
    <div class="capacity">
      <div class="capacity-main width_fixed">
        <ul>
          <li>
            <h4>100亿</h4>
            <p>全生态累计服务完成交易量</p>
          </li>
          <li>
            <h4>50+</h4>
            <p>接入产业数量</p>
          </li>
          <li>
            <h4>100+</h4>
            <p>接入金融机构数量</p>
          </li>
          <li>
            <h4>5000万</h4>
            <p>用户服务数量</p>
          </li>
          <li>
            <h4>10亿+</h4>
            <p>为产业赋能产生效益</p>
          </li>
        </ul>
      </div>
    </div>
    <div class="cooperation">
      <h4>携手共赢，让数据驱动一切</h4>
      <p></p>
      <div class="cooperation-img clearfix">
        <div class="cooperation-img-box clearfix" ref="cooperationImgBox">
          <ul class="clearfix">
            <li v-for="(item, index) in partners.batch1" :key="index"><img :src="item.imgUrl" :alt="item.title" :title="item.title"></li>
          </ul>
          <ul class="clearfix">
            <li v-for="(item, index) in partners.batch2" :key="index"><img :src="item.imgUrl" :alt="item.title" :title="item.title"></li>
          </ul>
        </div>
      </div>
      <div class="controller clearfix">
        <div class="controller-left active" ref="left" @click="handleCooperationImg('left')"></div>
        <div class="controller-right" ref="right" @click="handleCooperationImg('right')"></div>
      </div>
    </div>
    <Footer></Footer>
  </div>
</template>

<script>
import Header from '@/components/pc/header'
import Footer from '@/components/pc/footer'

export default {
  data () {
    return {
      bannerImgUrl: [
        {
          imgUrl: require('@/assets/img/pc/banner/banner_1.jpg'),
          href: '/business'
        },
      ],
      partners: {
        batch1: [
          {
            imgUrl: require('@/assets/img/pc/partners/partners-icon1.jpg'),
            title: '阿里巴巴'
          },
          {
            imgUrl: require('@/assets/img/pc/partners/partners-icon2.jpg'),
            title: '腾讯'
          },
          {
            imgUrl: require('@/assets/img/pc/partners/partners-icon3.jpg'),
            title: '小米'
          },
          {
            imgUrl: require('@/assets/img/pc/partners/partners-icon4.jpg'),
            title: '支付宝'
          },
          {
            imgUrl: require('@/assets/img/pc/partners/partners-icon5.jpg'),
            title: '中国人民银行'
          },
          {
            imgUrl: require('@/assets/img/pc/partners/partners-icon6.jpg'),
            title: '宝付'
          },
          {
            imgUrl: require('@/assets/img/pc/partners/partners-icon7.jpg'),
            title: '51公积金管家'
          },
          {
            imgUrl: require('@/assets/img/pc/partners/partners-icon8.jpg'),
            title: 'e签宝'
          },
          {
            imgUrl: require('@/assets/img/pc/partners/partners-icon9.jpg'),
            title: '大汉三通'
          },
          {
            imgUrl: require('@/assets/img/pc/partners/partners-icon10.jpg'),
            title: '易宝支付'
          }
        ],
        batch2: [
          {
            imgUrl: require('@/assets/img/pc/partners/partners-icon11.jpg'),
            title: '阿里云'
          },
          {
            imgUrl: require('@/assets/img/pc/partners/partners-icon12.jpg'),
            title: '手拉手'
          },
          {
            imgUrl: require('@/assets/img/pc/partners/partners-icon13.jpg'),
            title: '拉钩'
          },
          {
            imgUrl: require('@/assets/img/pc/partners/partners-icon14.jpg'),
            title: 'FACE++'
          },
          {
            imgUrl: require('@/assets/img/pc/partners/partners-icon15.jpg'),
            title: '依图YITU'
          },
          {
            imgUrl: require('@/assets/img/pc/partners/partners-icon16.jpg'),
            title: '连连支付'
          },
          {
            imgUrl: require('@/assets/img/pc/partners/partners-icon17.jpg'),
            title: '小能'
          },
          {
            imgUrl: require('@/assets/img/pc/partners/partners-icon18.jpg'),
            title: '快递鸟'
          },
          {
            imgUrl: require('@/assets/img/pc/partners/partners-icon19.jpg'),
            title: '友盟+'
          },
          {
            imgUrl: require('@/assets/img/pc/partners/partners-icon20.jpg'),
            title: '极光'
          }
        ]
      }
    }
  },
  methods: {
    handleCooperationImg(direction) {
      let imgbox = this.$refs.cooperationImgBox
      let left = this.$refs.left
      let right = this.$refs.right
      if (direction === 'left') {
        imgbox.style.left = '0'
        right.classList.remove('active')
        left.classList.add('active')
      } else {
        imgbox.style.left = '-1060px'
        left.classList.remove('active')
        right.classList.add('active')
      }
    }
  },
  components: {
    Header,
    Footer
  }
}
</script>

<style lang="less">
  @keyframes imgTop {
    0% {
      top: 60%;
      opacity: 0;
    }
    100% {
      top: 50%;
      opacity: 1;
    }
  }
  @keyframes imgIcon1 {
    0% {
      top: -80px;
    }
    90% {
      top: 122px;
    }
    100% {
      top: 112px;
    }
  }
  @keyframes imgIcon3 {
    0% {
      top: 640px;
    }
    90% {
      top: 244px;
    }
    100% {
      top: 234px;
    }
  }
  @keyframes imgIcon2 {
    0% {
      top: 640px;
    }
    90% {
      top: 322px;
    }
    100% {
      top: 312px;
    }
  }
  .banner {
    overflow: hidden;
    .banner-bg {
      width: 100%;
      height: 640px;
      background-size: cover;
      background-repeat: no-repeat;
      background-position: center;
      .banner-content {
        display: flex;
        justify-content: space-between;
        align-items: center;
        height: 100%;
        .banner-content-text {
          flex: 1;
          .banner-title {
            font-size:46px;
            font-family:PingFangSC-Light;
            font-weight:300;
            color:#fff;
          }
          .banner-text {
            font-size:24px;
            font-family:PingFangSC-Light;
            font-weight:300;
            color:#fff;
            margin-top: 25px;
          }
          .layer-btn {
            width:164px;
            line-height:43px;
            background: transparent;
            color: #FFA33D;
            border:1px solid #FFA33D;
            border-radius:2px;
            margin-top: 105px;
            text-align: center;
          }
        }
        .banner-icon {
          flex: 1;
          height: 100%;
          position: relative;
          img {
            position: absolute;
          }
          .banner-icon1,.banner-icon2,.banner-icon3 {
            width: 100%;
            animation: imgTop .8s ease-in;
            transform: translateY(-50%);
            top: 60%;
            animation-fill-mode: forwards;
          }
          .banner-icon4 {
            width: 80px;
            left: 46%;
            top: -80px;
            animation: imgIcon1 .4s ease-in .7s;
            animation-fill-mode: forwards;
          }
          .banner-icon5 {
            width: 100px;
            right: 108px;
            top: 640px;
            animation: imgIcon2 .4s ease-in 1s;
            animation-fill-mode: forwards;
          }
          .banner-icon6 {
            width: 110px;
            left: 87px;
            top: 640px;
            animation: imgIcon3 .4s ease-in 1.2s;
            animation-fill-mode: forwards;
          }
        }
      }
    }
    .banner-first{
      background-image: linear-gradient(30deg, #1b1919 0%, #341c13 100%);
    }
  }
  .serve {
    .serve-main {
      ul {
        display: flex;
        justify-content: center;
        padding: 63px 0 60px;
        li:nth-of-type(1) {
          margin-right: 67px;
          .icon {
            background: #fff3e1 url('~@/assets/img/pc/information-icon.png') no-repeat center;
            background-size: 50px;
          }
        }
        li:nth-of-type(2) {
          margin-left: 67px;
          .icon {
            background: #fff3e1 url('~@/assets/img/pc/rule-nor-icon.png') no-repeat center;
            background-size: 50px;
          }
        }
        li {
          flex: 1;
          text-align: center;
          .icon {
            margin: 0 auto;
            width: 90px;
            height: 90px;
            border-radius: 50%;
          }
          h5 {
            font-size:30px;
            font-family: PingFangSC, PingFangSC-Medium;
            font-weight:600;
            color:#333;
            line-height:42px;
            padding: 32px 0 px;
            margin-top: 32px;
            margin-bottom: 16px;
          }
          p {
            font-size: 16px;
            font-family: PingFangSC, PingFangSC-Regular;
            font-weight: 400;
            text-align: center;
            color: #666;
            line-height:22px;
          }
        }
      }
    }
  }
  .business {
    background: #f9f8f7;
    &-main {
      ul {
        display: flex;
        li {
          flex: 1;
          height: 420px;
          background-size: cover;
          background-repeat: no-repeat;
          background-position: center;
          text-align: center;
          position: relative;
          cursor: pointer;
          .li-box {
            position: absolute;
            left: 0;
            right: 0;
            top: 0;
            bottom: 0;
            background: rgba(0, 0, 0, .5);
            transition: all .3s;
          }
          .li-content {
            height: 100%;
            position: absolute;
            left: 0;
            right: 0;
            top: 0;
            bottom: 0;
            transition: top .3s;
            h3 {
              font-size:30px;
              font-weight:500;
              color:#fff;
              line-height:42px;
              margin-top: 64px;
            }
            p {
              font-size:16px;
              font-weight:400;
              color: #fff;
              position: relative;
              margin-top: 20px;
            }
            p:after {
              content: '';
              position: absolute;
              left: 50%;
              bottom: -24px;
              transform: translateX(-50%);
              width: 20px;
              border-bottom: 2px solid #fff;
            }
            .icon {
              display: block;
              width: 180px;
              height: 130px;
              background-size: cover;
              margin: 97px auto 0;
            }
            div {
              border: 1px solid #fff;
              color: #fff;
              background: transparent;
              width: 120px;
              line-height: 36px;
              font-size: 14px;
              display: block;
              margin: 0 auto;
              opacity: 0;
              transition: opacity .3s;
            }
          }
        }
        li:hover>.li-content {
          top: -50px;
          div {
            opacity: 1;
          }
        }
        li:hover>.li-box {
          background: #ff8b52;
          opacity: .9;
        }
        li:nth-of-type(1) {
          background-image: url('~@/assets/img/pc/business-bg1.png');
          .icon {
            background-image: url('~@/assets/img/pc/business-icon1.png');
          }
        }
        li:nth-of-type(2) {
          background-image: url('~@/assets/img/pc/business-bg2.png');
          .icon {
            background-image: url('~@/assets/img/pc/business-icon2.png');
          }
        }
        li:nth-of-type(3) {
          background-image: url('~@/assets/img/pc/business-bg3.png');
          .icon {
            background-image: url('~@/assets/img/pc/business-icon3.png');
          }
        }
        li:nth-of-type(4) {
          background-image: url('~@/assets/img/pc/business-bg4.png');
          .icon {
            background-image: url('~@/assets/img/pc/business-icon4.png');
          }
        }
      }
    }
  }
  .capacity {
    background: url('~@/assets/img/pc/wrap4-bg.jpg') no-repeat center;
    background-size: cover;
    padding: 117px 0 110px;
    &-main {
      ul {
        display: flex;
        li {
          flex: 1;
          text-align: center;
          h4 {
            font-size:36px;
            font-family:PingFangSC-Regular;
            font-weight:400;
            color:#F57319;
          }
          p {
            font-size:18px;
            font-family:PingFangSC-Light;
            font-weight:300;
            color:#333;
            padding-top: 24px;
          }
        }
      }
    }
  }
  .cooperation {
    text-align: center;
    padding: 70px 0 77px;
    h4 {
      font-size:30px;
      font-family:PingFangSC-Light;
      font-weight:300;
      color: #333;
    }
    p {
      margin-top: 16px;
      font-size:16px;
      font-family:PingFangSC-Regular;
      font-weight:400;
      color:#888;
    }
    &-img {
      width: 1060px;
      overflow: hidden;
      position: relative;
      height: 163px;
      margin: 56px auto 0;
      &-box {
        width: 2120px;
        position: absolute;
        left: 0;
        transition: all .3s;
        ul {
          width: 1060px;
          float: left;
          li {
            float: left;
            width: 200px;
            height: 73px;
            border: 1px solid #CBD1E6;
            overflow: hidden;
            box-sizing: border-box;
            margin-right: 15px;
            margin-bottom: 17px;
            img {
              width: 100%;
            }
          }
          li:nth-child(5n) {
            margin-right: 0px;
          }
        }
      }
    }
    .left {
      left: 0;
    }
    .right {
      right: 0;
    }
    .controller {
      display: flex;
      justify-content: center;
      margin-top: 30px;
      .controller-left, .controller-right {
        width: 29px;
        height: 7px;
        background: #FCDCCD;
        cursor: pointer;
        transition: all .2s;
      }
      .controller-left {
        margin-right: 6px;
      }
      .controller-left:hover , .controller-right:hover {
        background: #FF8B52;
      }
      .active {
        background: #FF8B52;
      }
    }
  }
</style>
